import { OlsConfigStore, CartStore } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';

export function orderNumber() {
  return CartStore.getState()?.order?.number;
}

export function checkoutUrl() {
  return `${OlsConfigStore.getState().olsPublishedSiteHost}/checkout${addTranslateHash()}`;
}

function addTranslateHash() {
  /* eslint-disable no-undef */
  const hasCookie = document.cookie && document.cookie.indexOf('googtrans') > -1;
  if (
    hasCookie &&
    typeof google === 'object' &&
    google.translate &&
    google.translate.TranslateElement
  ) {
    const translateInstance = google.translate.TranslateElement();
    const lang = translateInstance && translateInstance.c;
    return `#googtrans(${lang})`;
  }
  /* eslint-enable no-undef */

  return '';
}

export function getGclidValue() {
  return localStorage.getItem('gclid');
}

export function getGdanIdValue() {
  return localStorage.getItem('gdan_id');
}
